import React, { useEffect, useState, useRef } from "react";

const Dropdown = ({
  value,
  options,
  placeholder = "Select",
  onChange,
  toggle,
}) => {
  const node = useRef();

  const [open, setOpen] = useState(false);

  const handleClickOutside = (e) => {
    if (node.current.contains(e.target)) {
      return;
    }
    setOpen(false);
  };

  const handleChange = (selectedValue) => {
    onChange(selectedValue);
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div ref={node} className="dropdown">
      {toggle ? (
        toggle(open, setOpen)
      ) : (
        <button className="dropdown-toggle" onClick={(e) => setOpen(!open)}>
          {value || placeholder}
        </button>
      )}
      {open && (
        <ul className="dropdown-query-builder-export">
          {options &&
            options.length > 0 &&
            options.map((opt, i) => (
              <li
                className="dropdown-menu-item"
                key={i}
                onClick={(e) => handleChange(opt)}
              >
                {opt}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
